/**
 * GL Codes API Service
 * Handles GL chart-of-accounts operations.
 *
 * Base URL: /api (apiFetch adds /api prefix)
 */
import { useCallback, useMemo } from "react";
import { useApi } from "@/hooks/use-api";
import type { GlCodeDto } from "@/types/api/gl-codes";

const GL_CODES_BASE = "/glcodes";

/**
 * Hook providing GL code API operations with authentication
 */
export function useGlCodesApi() {
    const api = useApi();

    /**
     * List the GL chart of accounts for the authenticated user's client
     * GET /api/glcodes
     */
    const getGlCodes = useCallback(async (): Promise<GlCodeDto[]> => {
        return api.get<GlCodeDto[]>(GL_CODES_BASE);
    }, [api]);

    return useMemo(
        () => ({
            getGlCodes,
        }),
        [getGlCodes],
    );
}
